import { CalendarCheck2, CalendarDays, CircleCheck, Repeat, Target, type LucideIcon } from 'lucide-react';
import type { CalendarItemKind } from '../../../lib/calendar/calendar-item';

// Every kind has its own glyph and its own word, so no item relies on colour to say what it is.
export const KIND_ICON: Record<CalendarItemKind, LucideIcon> = {
  meeting: CalendarDays,
  booking: CalendarCheck2,
  task: CircleCheck,
  routine: Repeat,
  goal: Target,
};

export const KIND_LABEL_KEY: Record<CalendarItemKind, string> = {
  meeting: 'calendar.kind.meetings',
  booking: 'calendar.kind.bookings',
  task: 'calendar.kind.tasks',
  routine: 'calendar.kind.routines',
  goal: 'calendar.kind.goals',
};

/** The class that sets `--kind` and `--kind-rgb` for an item's accent. */
export const KIND_CLASS: Record<CalendarItemKind, string> = {
  meeting: 'kindMeeting',
  booking: 'kindBooking',
  task: 'kindTask',
  routine: 'kindRoutine',
  goal: 'kindGoal',
};
